import type { Message } from './types';

export async function getMessages(): Promise<Message[]> {
  const res = await fetch('/api/messages');
  if (!res.ok) throw new Error('Failed to fetch messages');
  return res.json();
}

export async function getAdminMessages(secret: string): Promise<Message[]> {
  const res = await fetch('/api/admin/messages', {
    headers: { 'X-Admin-Secret': secret },
  });
  if (!res.ok) throw new Error('Unauthorized');
  return res.json();
}

export async function submitMessage(data: {
  from: string;
  email: string;
  message: string;
  image_url?: string;
}): Promise<void> {
  const res = await fetch('/api/submit', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({})) as { error?: string };
    throw new Error(err.error ?? 'Submission failed');
  }
}

export async function activateMessage(code: string): Promise<void> {
  const res = await fetch(`/api/activate?code=${encodeURIComponent(code)}`);
  if (!res.ok) {
    const err = await res.json().catch(() => ({})) as { error?: string };
    throw new Error(err.error ?? 'Activation failed');
  }
}

export async function deleteMessage(code: string): Promise<void> {
  const res = await fetch(`/api/delete?code=${encodeURIComponent(code)}`);
  if (!res.ok) {
    const err = await res.json().catch(() => ({})) as { error?: string };
    throw new Error(err.error ?? 'Delete failed');
  }
}

export async function uploadImage(file: File): Promise<string> {
  const form = new FormData();
  form.append('file', file);
  const res = await fetch('/api/upload', { method: 'POST', body: form });
  if (!res.ok) throw new Error('Upload failed');
  const { url } = await res.json() as { url: string };
  return url;
}

export async function adminDelete(id: string, secret: string): Promise<void> {
  const res = await fetch(`/api/admin/delete/${id}`, {
    method: 'POST',
    headers: { 'X-Admin-Secret': secret },
  });
  if (!res.ok) throw new Error('Admin delete failed');
}

export async function adminActivate(id: string, secret: string): Promise<void> {
  const res = await fetch(`/api/admin/activate/${id}`, {
    method: 'POST',
    headers: { 'X-Admin-Secret': secret },
  });
  if (!res.ok) throw new Error('Admin activate failed');
}

export async function adminRestore(id: string, secret: string): Promise<void> {
  const res = await fetch(`/api/admin/restore/${id}`, {
    method: 'POST',
    headers: { 'X-Admin-Secret': secret },
  });
  if (!res.ok) throw new Error('Admin restore failed');
}
